import { BI_CONSTANTS } from './biConstants';
import { useMemo } from 'react';
import { config } from '../../config';
import { SITE_PREVIEW_URL, STORE_NAME_URL, TEMPLATE_SELECTION_URL } from '../../consts';

const onlyQuery = '([\\/]{0,1})(?=\\?|$)';

enum AppScreens {
  CHAT = 'chat',
  CATEGORY_PAGE = 'categoryPage',
  PRODUCTS_PAGE = 'productsPage',
  TEMPLATE_PAGE = 'templatePage',
  STORE_NAME_PAGE = 'storeNamePage',
  SITE_PREVIEW_PAGE = 'sitePreviewPage',
  UNKNOWN = 'unknown',
}

const AppScreensMatchers = {
  CATEGORY_PAGE: {
    regex: new RegExp(`^(?:[\\/]){0,1}(?=\\?|$)`),
    screen: AppScreens.CATEGORY_PAGE,
  },
  TEMPLATE_PAGE: {
    regex: new RegExp(`(\\${TEMPLATE_SELECTION_URL}|\\/business-name-generator)${onlyQuery}`),
    screen: AppScreens.TEMPLATE_PAGE,
  },
  STORE_NAME_PAGE: {
    regex: new RegExp(`(\\${STORE_NAME_URL}|\\/business-name-generator)${onlyQuery}`),
    screen: AppScreens.STORE_NAME_PAGE,
  },
  SITE_PREVIEW_PAGE: {
    regex: new RegExp(`(\\${SITE_PREVIEW_URL}|\\/business-name-generator)${onlyQuery}`),
    screen: AppScreens.SITE_PREVIEW_PAGE,
  },
  PRODUCTS_PAGE: {
    regex: new RegExp(`\\/products${onlyQuery}`),
    screen: AppScreens.PRODUCTS_PAGE,
  },
};

const getScreenName = (appScreen: AppScreens) => {
  const { SCREENS } = BI_CONSTANTS;

  switch (appScreen) {
    case AppScreens.CATEGORY_PAGE:
      return SCREENS.CATEGORY_PAGE;
    case AppScreens.PRODUCTS_PAGE:
      return SCREENS.PRODUCT_PAGE;
    case AppScreens.CHAT:
      return SCREENS.CHAT;
    case AppScreens.TEMPLATE_PAGE:
      return SCREENS.TEMPLATE_PAGE;
    case AppScreens.STORE_NAME_PAGE:
      return SCREENS.STORE_NAME_PAGE;
    case AppScreens.SITE_PREVIEW_PAGE:
      return SCREENS.SITE_PREVIEW_PAGE;
    default:
      return SCREENS.UNKNOWN;
  }
};

export const useBiScreen = () => {
  return useMemo(() => {
    let pathname = window.location.pathname;
    if (config.env === `production`) {
      pathname = pathname.replace(config.baseUrl, '');
    }
    const screenMatcher = Object.values(AppScreensMatchers).find((matcher) => matcher.regex.test(pathname));
    const appScreen = screenMatcher?.screen ?? AppScreens.UNKNOWN;

    return {
      screen: {
        name: getScreenName(appScreen),
      },
    };
  }, []);
};

export const getReferralInfo = () => {
  const queryParams = new URLSearchParams(window.location.search);

  const utmCampaign = queryParams.get('utm_campaign');
  if (utmCampaign) {
    return Array.isArray(utmCampaign) ? utmCampaign[0] : utmCampaign;
  }

  const referralInfo = queryParams.get('referralInfo');
  return Array.isArray(referralInfo) ? referralInfo[0] : referralInfo;
};
